<template>
    <div class="">
        <div class="flex justify-between flex-wrap items-center my-2">
            <div class="flex flex-wrap gap-4 pr-5 text-xs py-2">
                <v-text-field placeholder="Full Name" variant="outlined" class="w-32" density="compact" @keyup.enter="searchFilter" v-model="filterName" rounded="0">
                </v-text-field>
                <v-text-field placeholder="Customer Email" variant="outlined" class="w-32" density="compact" @keyup.enter="searchFilter" v-model="filterEmail" rounded="0">
                </v-text-field>
                <v-btn icon="mdi-magnify" size="small" style="outline: none;" @click="searchFilter" class="bg-dark text-light"></v-btn>
            </div>
            <div>
                <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteCustomers"
                    class="mr-5 bg-dark text-light"></v-btn>
                <v-btn icon="mdi-plus" size="small" style="outline: none;" @click="addNewUser" data-bs-toggle="modal"
                    data-bs-target="#customerAddModal" class="bg-dark text-light"></v-btn>
            </div>
        </div>
        <v-data-table :headers="headers" :items="Users" id="tablecontainer"
            item-value="uuid" v-model:expanded="expanded" @click:row="onRowClick" class="border h-[500px] bg-white text-black min-h-[500px] customer-table" 
            items-per-page="-1" show-expand 
            style="font-size: 13px;" :style="`height: ${computedHeight}px;`">
            <template v-slot:[`item.no`]="{ index }">
                {{ index + 1 }}
            </template>
            <template v-slot:[`item.checkbox`]="{ item }">
                <div @click="toggleSelection(item)" class="ml-auto align-self-center"
                    style="width: 20px; height: 20px; cursor: pointer;">
                    <input :checked="isSelected(item)" class="form-check-input shadow-none" type="checkbox" />

                </div>
            </template>
            <template v-slot:[`item.licenses`]="{ item }">
                <router-link
                    class="text-white"
                    :to="{ name: 'AdminLicensePage', query: { email: item.email }}"
                >
                    View
                </router-link>
            </template>
            <template v-slot:[`item.age`]="{ item }">
                <span class="nowrap" :class="{ 'age-new': ageDays(item.createdDate) < 7 }">{{ ageText(item.createdDate) }}</span>
            </template>
            <template v-slot:[`item.licences_col`]="{ item }">
                <span class="tabular-nums nowrap">{{ item.licenses_active || 0 }} active / {{ item.licenses_total || 0 }}</span>
            </template>
            <template v-slot:[`item.topups_col`]="{ item }">
                <span class="tabular-nums nowrap">${{ money(item.topup_total) }} · {{ item.topups || 0 }}</span>
            </template>
            <!-- the same summary as the Messages tab header, fetched when the row is opened -->
            <template v-slot:expanded-row="{ columns, item }">
                <tr class="customer-detail">
                    <td :colspan="columns.length">
                        <div v-if="!summaries[item.user_id]" class="customer-detail__inner text-gray-500">Loading account summary…</div>
                        <div v-else-if="summaries[item.user_id].error" class="customer-detail__inner text-gray-500">Could not load the account summary.</div>
                        <div v-else class="customer-detail__inner">
                            <div class="cd-tiles">
                                <div class="cd-tile"><span>Account</span><b>{{ ageText(summaries[item.user_id].created_at) }}</b><small>since {{ fmtDate(summaries[item.user_id].created_at) }}</small></div>
                                <div class="cd-tile"><span>Licences</span><b>{{ summaries[item.user_id].licenses_total }}</b><small>{{ summaries[item.user_id].licenses_active }} active now</small></div>
                                <div class="cd-tile"><span>Purchases</span><b>{{ summaries[item.user_id].purchases }}</b><small>${{ money(summaries[item.user_id].purchase_total) }}<template v-if="summaries[item.user_id].last_purchase_at"> · last {{ fmtDate(summaries[item.user_id].last_purchase_at) }}</template></small></div>
                                <div class="cd-tile"><span>Extensions</span><b>{{ summaries[item.user_id].extensions }}</b><small>renewals</small></div>
                                <div class="cd-tile"><span>Top-ups</span><b>${{ money(summaries[item.user_id].topup_total) }}</b><small>{{ summaries[item.user_id].topups }} top-up{{ summaries[item.user_id].topups === 1 ? '' : 's' }}<template v-if="summaries[item.user_id].last_topup_at"> · last {{ fmtDate(summaries[item.user_id].last_topup_at) }}</template></small></div>
                                <div class="cd-tile"><span>Balance</span><b>${{ money(summaries[item.user_id].balance) }}</b><small>available</small></div>
                            </div>
                            <div class="cd-ip">
                                <template v-if="summaries[item.user_id].ipaddress">
                                    <span class="cd-label">Reg. IP</span> <b>{{ summaries[item.user_id].ipaddress }}</b>
                                    <template v-if="summaries[item.user_id].ip_geo"> · {{ summaries[item.user_id].ip_geo.country }}<template v-if="summaries[item.user_id].ip_geo.city"> ({{ summaries[item.user_id].ip_geo.city }})</template></template>
                                    <span v-if="summaries[item.user_id].ip_geo && (summaries[item.user_id].ip_geo.proxy || summaries[item.user_id].ip_geo.hosting)" class="cd-flag cd-flag--bad">VPN / hosting IP</span>
                                    <span v-if="summaries[item.user_id].country && summaries[item.user_id].ip_geo && summaries[item.user_id].ip_geo.country !== summaries[item.user_id].country" class="cd-flag cd-flag--warn">profile says {{ summaries[item.user_id].country }}</span>
                                </template>
                                <template v-else-if="summaries[item.user_id].country"><span class="cd-label">Country (profile)</span> {{ summaries[item.user_id].country }}</template>
                            </div>
                            <div class="cd-btns">
                                <router-link class="cd-btn" :to="{ name: 'AdminLicensePage', query: { email: item.email } }">Licenses</router-link>
                                <router-link class="cd-btn" :to="{ path: '/admin/chat', query: { user_id: item.user_id } }">Open chat</router-link>
                                <router-link class="cd-btn" :to="{ path: '/admin/audit', query: { user_id: item.user_id } }">Activity</router-link>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <template v-slot:[`item.createdDate`]="{ item }">
                {{formatDate(item.createdDate)}}
            </template>
            <template v-slot:[`item.tglink`]="{ item }">
                <a v-if="item.tglink" class="flex flex-row items-center gap-x-2 px-3" :href="formatTgLink(item.tglink)" target="_blank">
                    <img class="w-[30px] h-[30px]" src="../../../assets/tg.png" />
                </a>
            </template>
            <template v-slot:[`item.buttonBar`]="{ item }">
                <v-menu offset-y location="bottom">
                    <template v-slot:activator="{ props, on, isActive }">
                        <v-btn v-bind="props" v-on="{ ...on }" color="#234" density="compact"
                            :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                            style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                            Actions
                            <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                        </v-btn>
                    </template>
                    <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                        style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                        <v-btn v-for="(button, index) in actionButtons" :key="index" @click="clickAction(item, button)"
                            rounded="0" class="text-center bg-dark text-light"
                            style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                            :data-bs-toggle="(button === 'Update' || button === 'Adjust') && 'modal'"
                            :data-bs-target="button === 'Update' ? '#customerUpdateModal' : button === 'Adjust' ? '#refundModal': ''">
                            {{
                    button }}
                        </v-btn>
                    </v-list>
                </v-menu>
            </template>
            <template #bottom></template>
        </v-data-table>
    </div>
    <div>
        <AddNewOneDialog @close="addNewOneDialogFlag = false" @updated="updatedHandler" />
        <UpdateInfoDialog @close="updateInfoDialogFlag = false" :item="selectedItem" @updated="updatedHandler" />
        <RefundDialog @close="refundDialogFlag = false" :item="selectedItem" @updated="updatedHandler" />

    </div>
</template>
<script setup>
import { ref, reactive, watch, onMounted, onBeforeUnmount } from 'vue';
import { fetchWrapper } from '@/helpers';
import { useAdminUserStore, useAlertStore } from "@/stores"
import { proxiesCsv, downloadText, exportName } from "@/helpers/proxyExport"
import { storeToRefs } from 'pinia';
import AddNewOneDialog from "./Modals/AddNewOneDialog.vue"
import UpdateInfoDialog from "./Modals/UpdateInfoDialog.vue"
import RefundDialog from "./Modals/RefundDialog.vue"

const appName = process.env.VUE_APP_VUE_NAME
let count = 0;

const headers = ref(
    [
        { title: 'No', align: 'center', key: 'no' },
        { title: '', align: 'center', key: 'checkbox' },
        { title: 'User Name', align: 'center', key: 'user_name' },
        { title: 'Full Name', align: 'center', key: 'name' },
        { title: 'Email', align: 'center', key: 'email' },
        { title: 'Age', align: 'center', key: 'age', sortable: false },
        { title: 'Licences', align: 'center', key: 'licences_col', sortable: false },
        { title: 'Top-ups', align: 'center', key: 'topups_col', sortable: false },
        { title: 'Role', align: 'center', key: 'role' },
        { title: 'Balance', align: 'center', key: 'balance' },
        { title: 'Address', align: 'center', key: 'address' },
        { title: 'City', align: 'center', key: 'city' },
        { title: 'Country', align: 'center', key: 'country' },
        { title: 'IP', align: 'center', key: 'ipAddress' },
        { title: 'Created Date', align: 'center', key: 'createdDate' },
        { title: 'Telegram', align: 'center', key: 'tglink' },
        { title: 'Licenses', align: 'center', key: 'licenses'},
        ...(appName === 'global' ? [{ title: 'Rotation Min', align: 'center', key: 'rotation_min' }] : []),
        { title: 'Actions', align: 'center', key: 'buttonBar' },
    ]
);

const addNewOneDialogFlag = ref(false)
const updateInfoDialogFlag = ref(false)
const refundDialogFlag = ref(false)
const filterEmail = ref("")
const filterName = ref("")


const adminUserStore = useAdminUserStore()
const { Users } = storeToRefs(adminUserStore)

const selectedItems = ref([]);

// ---- account summary (same as the Messages tab) ----
const expanded = ref([]);
const summaries = reactive({});   // user_id -> summary (or { error: true })
const money = (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = (d) => d ? new Date(d).toLocaleDateString() : '-';
const ageDays = (d) => d ? Math.floor((Date.now() - new Date(d).getTime()) / 86400000) : Infinity;
const ageText = (d) => {
    const days = ageDays(d);
    if (!Number.isFinite(days)) return '-';
    if (days < 1) return 'today';
    if (days < 60) return days + ' day' + (days === 1 ? '' : 's');
    const months = Math.floor(days / 30.44);
    if (months < 24) return months + ' months';
    const years = Math.floor(months / 12), rem = months % 12;
    return years + ' yr' + (rem ? ' ' + rem + ' mo' : '');
};
const loadSummary = async (userId) => {
    if (!userId || summaries[userId]) return;
    try { summaries[userId] = await fetchWrapper.get(`${process.env.VUE_APP_VUE_API_URL}/admin/user/summary?user_id=${userId}`); }
    catch (e) { summaries[userId] = { error: true }; }
};
watch(expanded, (uuids) => {
    for (const uuid of uuids) { const u = (Users.value || []).find((x) => x.uuid === uuid); if (u) loadSummary(u.user_id); }
});
// a click anywhere on the row opens / closes it, except on its own controls
const onRowClick = (event, { item }) => {
    if (event?.target?.closest && event.target.closest('button, a, input, .v-menu, .v-btn')) return;
    const uuid = item?.uuid ?? item?.raw?.uuid;
    if (!uuid) return;
    expanded.value = expanded.value.includes(uuid) ? expanded.value.filter((x) => x !== uuid) : [...expanded.value, uuid];
};
const selectedItem = ref(null);

const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const formatDate = (dateStr) => {
    try {
        const date = new Date(dateStr);
        const formattedDate = date.toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        });
        return formattedDate
    } catch(err) {
        return ""
    }
}

const handleResize = () => {
    computedHeight.value = window.innerHeight - offsetHeight;
};
const formatTgLink = (tglink) => {
    if(tglink) {
    const cleanedID = tglink.replace(/(@|https?:\/\/t\.me\/)/g, "").trim();
    const telegramUrl = `https://t.me/${cleanedID}`;
    return telegramUrl;
    } else return ''
}
onMounted(() => {
  window.addEventListener('resize', handleResize);
  count = 50;
  adminUserStore.loadUsers({name: filterName.value, email: filterEmail.value, from: 0, count: 50})
  const element = document.getElementById('tablecontainer').children[0]
  element.addEventListener('scroll', onScroll)
});

const onScroll = (event) => {
  const table = event.target;
  if (table.scrollTop + table.clientHeight >= table.scrollHeight) {
    adminUserStore.loadUsers({name: filterName.value, email: filterEmail.value, from: count, count: 20});
    count += 20;
  }
};

const searchFilter = () => {
    count = 50;
    adminUserStore.loadUsers({name: filterName.value, email: filterEmail.value, from: 0, count: 50});
}

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  const element = document.getElementById('tablecontainer').children[0]
  element.removeEventListener('scroll', onScroll)
});

const isSelected = (item) => {
    return selectedItems.value.includes(item); 
};

const toggleSelection = (item) => {
    const index = selectedItems.value.indexOf(item);
    if (index === -1) {
        selectedItems.value.push(item);
    } else {
        selectedItems.value.splice(index, 1);
    }
};




const addNewUser = () => {
    addNewOneDialogFlag.value = true
}
const actionButtons = ref(
    ["Update", "Adjust", "Export CSV", "Log out"]
)
const exportFor = async (item) => {
    const r = await adminUserStore.exportProxies(item.user_id, 'csv')
    if (!r) return
    if (!r.proxies.length) { useAlertStore().error(`${r.email} has no active proxies`); return }
    downloadText(exportName(r.email, 'csv'), proxiesCsv(r.proxies, { email: r.email }), 'text/csv;charset=utf-8')
}
const clickAction = (item, button) => {
    selectedItem.value = item
    switch (button) {
        case "Update":
            updateInfoDialogFlag.value = true
            break
        case "Adjust":
            refundDialogFlag.value = true
            break
        case "Export CSV":   // the customer's active proxies (audited)
            exportFor(item)
            break
        case "Log out":   // ends every sign-in of this user (API keys keep working)
            if (window.confirm(`Log ${item.email || 'this user'} out everywhere? They will have to sign in again.`)) adminUserStore.logoutUser(item.user_id)
            break
    }
}

const updatedHandler = () => {
    addNewOneDialogFlag.value = false
    updateInfoDialogFlag.value = false
    refundDialogFlag.value = false
    count = 50;
    adminUserStore.loadUsers({name: filterName.value, email: filterEmail.value, from: 0, count: 50})
}

const deleteCustomers = () => {
    adminUserStore.deleteUsers(selectedItems.value.map(item => item.uuid)).then(() => {
        count = 50;
        adminUserStore.loadUsers({name: filterName.value, email: filterEmail.value, from: 0, count: 50})
    })

}
</script>

<style scoped>
.customer-table :deep(tbody tr) { cursor: pointer; }
.age-new { padding: 1px 7px; border-radius: 999px; background: var(--ui-warn-soft); color: var(--ui-warn-ink); font-weight: 600; }
.tabular-nums { font-variant-numeric: tabular-nums; }
.nowrap { white-space: nowrap; }
.cd-label { color: var(--ui-dim); }
.customer-detail > td { padding: 0 !important; background: var(--ui-card-2); text-align: left; }
.customer-detail__inner { display: grid; gap: 10px; padding: 12px 16px 14px 48px; }
.cd-tiles { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 10px; }
@media (max-width: 1100px) { .cd-tiles { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
.cd-tile { display: grid; gap: 1px; padding: 8px 11px; border: 1px solid var(--ui-line); border-radius: 8px; background: var(--ui-card); color: var(--ui-ink); }
.cd-tile span { font-size: 11px; letter-spacing: 0.05em; text-transform: uppercase; color: var(--ui-dim); }
.cd-tile b { font-size: 16px; font-weight: 600; font-variant-numeric: tabular-nums; }
.cd-tile small { font-size: 12px; color: var(--ui-dim); }
.cd-ip { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 10px; font-size: 13px; color: var(--ui-ink); }
.cd-flag { padding: 1px 8px; border-radius: 999px; font-size: 11.5px; font-weight: 700; }
.cd-flag--bad { background: #4a2a33; color: #ffd6d4; }
.cd-flag--warn { background: var(--ui-warn-soft); color: var(--ui-warn-ink); }
.cd-btns { display: flex; gap: 8px; }
.cd-btn { padding: 5px 12px; border-radius: 4px; background: #1d1c2b; color: #ffffff !important; font-size: 12px; font-weight: 600; text-decoration: none; }
.cd-btn:hover { background: #2c2b40; }
</style>
